import WidgetModule from "@eisinc/Overrides/Widgets/OrderHistory/SearchFieldWrapper";

export * from "@eisinc/Overrides/Widgets/OrderHistory/SearchFieldWrapper";

export default WidgetModule;
